module.exports = __webpack_public_path__ + "87c6a51ccb9860e19e10708b5ff8100f.webp";